// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__3CwZr","card":"CardsSwiper_card__bbZHn","active":"CardsSwiper_active__1Bgiw"};